import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import ContestListView from "./ContestListView";

const useStyles = makeStyles(() => ({
  root: {},
  logo: {
    textAlign: "center",
  },
}));

function HomeView() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.logo}>
        <img src="logo_with_service_name.png" alt="ロゴ" width="250px" />
      </div>
      <div>
        <h2>謎コンとは？</h2>
        <p>謎解きの問題を使ったコンテストを開催するWebサービスです。</p>
        <p>定期的にコンテストを開催する予定なのでぜひご参加ください！</p>
        <h2>コンテストのルール</h2>
        <p>
          時間内に問題を解いた数と最後に正解した時間で順位が付けられます。
        </p>
        <p>
          ユーザにはレーティングがありコンテスト終了後に順位に応じて変動します。現在のランキングは
          <a href="/ranking">こちら</a>
        </p>
        <p>
          コンテスト中にSNS等で答えやヒントに言及するのはお控えください。コンテスト終了後であれば特に制限はありません。
        </p>
        <h2>コンテスト一覧</h2>
        <ContestListView />
        <h2>ご要望・お問い合わせ</h2>
        <p>
          サイトに関するご要望やお問い合わせ等がありましたらお気軽に
          <a href="https://twitter.com/nazoconofficial" target="_blank">公式Twitter</a>
          までご連絡ください。
        </p>
      </div>
    </div>
  );
}

HomeView.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default HomeView;
